import { SavedFilter, SavedFilterCategory } from './SavedFilterPicker';

// comparison function to alphabetically sort the saved filters
export const savedFilterAlphaCompare = (a: SavedFilter, b: SavedFilter) =>
	a.name.toLowerCase().localeCompare(b.name.toLowerCase());

/**
 * Flattens structure that holds saved filter categories and filters to only return all filters
 */
export const flattenSavedFilters = (savedFilterCategories: SavedFilterCategory[]): SavedFilter[] => {
	return savedFilterCategories
		.reduce((acc: SavedFilter[], value: SavedFilterCategory) => {
			acc = acc.concat(value.savedFilters);
			return acc;
		}, [])
		.sort(savedFilterAlphaCompare);
};
